import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Container } from "react-bootstrap";
import { MdModeEditOutline, MdDeleteForever } from "react-icons/md";
import { Link } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";
import "./projet.css";

function Project() {
  const [competitions, setCompetitions] = useState([]);
  const [selectedItem, setSelectedItem] = useState("competition");

  const navigate = useNavigate();

  const handleEditClick = (competition) => {
    navigate("/ModifierComp", { state: { selectedCompetition: competition } });
  };
  const handleDeleteClick = (idcompetition) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette compétition ?")) {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/DeleteCompetition.php`,
          { idcompetition },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Delete response:", response.data);
          if (response.data.message === "Competition deleted successfully.") {
            alert("Compétition supprimée avec succès.");
            // Remove the deleted competition from the UI
            setCompetitions(
              competitions.filter(
                (comp) => comp.idcompetition !== idcompetition
              )
            );
          } else {
            alert("Erreur lors de la suppression de la compétition : " + response.data.message);
          }
        })
        .catch((error) => {
          console.error("Error deleting competition:", error);
          alert("Une erreur est survenue lors de la suppression de la compétition.");
        });
    }
  };

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/getCompitition.php`
        );
        setCompetitions(response.data);
      } catch (error) {
        console.error("Error fetching competitions:", error);
      }
    };

    fetchCompetitions();
  }, []);

  return (
    <div className="d-flex">
      <AdminSidebar />
      {selectedItem === "competition" && (
        <div className="competition-container">
          <div className="competition-content">
            <h1 className="table-title">COMPÉTITIONS</h1>
            <Link to={"/AjouteruneComp"}>
              <button className="add-btn">+ Ajouter une compétition</button>
            </Link>
            <table className="competition-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Titre</th>
                <th>Libellé</th>
                <th>Date de début</th>
                <th>Date de fin</th>
                <th>En ligne</th>
                <th>Année de compétition</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {competitions.map((competition, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{competition.titre}</td>
                  <td>{competition.libelle}</td>
                  <td>{competition.date_debut}</td>
                  <td>{competition.date_fin}</td>
                  <td>{competition.enligne === "1" ? "Oui" : "Non"}</td>
                  <td>{competition.annee_competition}</td>
                  <td>
                    <button
                      className="edit-btn"
                      onClick={() => handleEditClick(competition)}
                    >
                      <MdModeEditOutline />
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() =>
                        handleDeleteClick(competition.idcompetition)
                      }
                    >
                      <MdDeleteForever />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Project;
